module.exports = __webpack_public_path__ + "static/media/service.65172ea4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ActivityBadge/icons/service.svg
// module id = 298
// module chunks = 0